class SettingController {
  constructor ($scope) {
    Object.assign(this, { $scope })
  }
}

SettingController.$$ngIsClass = true
SettingController.$inject = ['$scope']

export default SettingController
